import $x from '@/utils/$x';

// 查询周质量数据
export async function queryQualityData(params) {
  return $x.post('/metaspace/quality-business-data/query', params);
}

// 提交缺陷
export async function sendMassDefect(params) {
  return $x.post('/metaspace/quality-business-data/submit-bugs', params);
}

// 挑战仪表盘
export async function roundList(params) {
  return $x.post('/dk/tj/list', params);
}
